import React from 'react';
import PagesList from '../components/Pages/PagesList';

const PagesManagement = () => {
  return (
    <>
      <div className="content_wrapper all_products_main">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="box_main">
                <div className="header_top">
                  <h3>Pages Management</h3>
                  <p className="text-muted">Manage landing pages and content</p>
                </div>
                <div className="">
                  <PagesList />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PagesManagement;
